<template>
  <!-- 车镇文章详情 -->
  <div class="box cza">
    <div class="min_box">
      <div v-html="data">{{ data }}</div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/loading";
export default {
  name: "Czarticle",
  components: {
    Loading,
  },
  data() {
    return {
      isM: false,
      data: "",
    };
  },
  created() {
    document.title = this.$route.query.title;
    var temp = document.createElement("div");
    temp.innerHTML = this.$route.query.data;
    this.data = this.$route.query.data;
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Cartownnews/Czarticle.vue